const getCurrentYear = () => {
  return new Date().getFullYear();
};

export { getCurrentYear };
